import { ResumeProfile, ResumeWorkExperience } from "lib/redux/types";
import React from "react";
import { TemplateSevenProfileSection } from "./common";
import { ResumePDFLink, ResumePDFText } from "../ResumePDF/common";
import { spacing, styles } from "../ResumePDF/styles";
import { View } from "@react-pdf/renderer";
import { IconType, ResumePDFIcon } from "../ResumePDF/common/ResumePDFIcon";
import { extractUsernameFromURL } from "lib/utils/urlHelpers";

const Profile = ({
  profile,
  themeColor,
  isPDF,
  workExperiences,
}: {
  profile: ResumeProfile;
  themeColor: string;
  isPDF: boolean;
  workExperiences: ResumeWorkExperience[];
}) => {
  const { name, email, phone, url1, url2, summary, location } = profile;
  const iconProps = { email, phone, location, url1, url2 };
  return (
    <TemplateSevenProfileSection style={{ marginTop: spacing["4"] }}>
    <View style={{ gap: 20, ...styles.flexRow, alignItems: "flex-end" }}>
  <ResumePDFText
    bold={true}
    themeColor={themeColor}
    style={{
      fontSize: "30pt",
      alignSelf: "flex-end",
      //  border:"1px solid green ",
      // marginBottom: 2,
    }}
  >
    {name}
  </ResumePDFText>
  
</View>



      <View style={{ ...styles.flexRow, gap: 25, flexWrap: "wrap",marginTop:spacing['1.5'] }}>
        {Object.entries(iconProps).map(([key, value]) => {
          if (!value) return null;
          let iconType = key as IconType;
          let displayValue = value;
          if (key == "url1" || key == "url2") {
            if (value.includes("github")) {
              iconType = "url_github";
            } else if (value.includes("behance")) {
              iconType = "url_behance";
            } else if (value.includes("linkedin")) {
              iconType = "url_linkedin";
            } else if (value.includes("dribble")) {
              iconType = "url_dribble";
            }
            displayValue = extractUsernameFromURL(value);
          }

          const shouldUseLinkWrapper = [
            "email",
            "url1",
            "url2",
            "phone",
          ].includes(key);
          const Wrapper = ({ children }: { children: React.ReactNode }) => {
            if (!shouldUseLinkWrapper) return <>{children}</>;
            let src = "";
            switch (key) {
              case "email": {
                src = `mailto:${value}`;
                break;
              }
              case "phone": {
                src = `tel:${value.replace(/[^\d+]/g, "")}`;
                break;
              }
              default: {
                src = value.startsWith("http") ? value : `https://${value}`;
              }
            }

            return (
              <ResumePDFLink src={src} isPDF={isPDF}>
                {children}
              </ResumePDFLink>
            );
          };

          return (
            <View
              key={key}
              style={{
                ...styles.flexRow,
                alignItems: "center",
                gap: spacing["1"],
              }}
            >
              <ResumePDFIcon
                type={iconType}
                isPDF={isPDF}
                themeColor={themeColor}
              />

              <Wrapper>
                <ResumePDFText>{displayValue}</ResumePDFText>
              </Wrapper>
            </View>
          );
        })}
      </View>
    </TemplateSevenProfileSection>
  );
};

export default Profile;
